
<template>
  <div class="path-surveys-display">
    <b-form-group
      label="希望エリア"
      class="mb-0">
      <BaseCheckboxGroup
        :value="pathSurveys.residencePreference"
        :options="selectedResidencePreferenceOptions"
        class="display-checkbox-group"
        disabled />
    </b-form-group>
    <b-form-group
      label="希望進路"
      class="mb-0">
      <BaseCheckboxGroup
        :value="pathSurveys.preferredPath"
        :options="selectedPreferredPathOptions"
        class="display-checkbox-group"
        disabled />
    </b-form-group>
    <b-form-group
      label="受験タイプ"
      class="mb-0">
      <BaseCheckboxGroup
        :value="pathSurveys.examType"
        :options="selectedExamTypeOptions"
        class="display-checkbox-group"
        disabled />
    </b-form-group>
    <b-form-group label="自宅の最寄駅・バス停">
      <div class="display-field">
        {{ pathSurveys.nearestStation }}
      </div>
    </b-form-group>
    <b-form-group label="最寄駅・バス停までの時間">
      <div class="display-field">
        {{ pathSurveys.accessTime }}
      </div>
    </b-form-group>
    <b-form-group label="生徒希望欄">
      <DisplayTextarea
        :content="pathSurveys.preference" />
    </b-form-group>
    <b-form-group label="保護者希望欄">
      <DisplayTextarea
        :content="pathSurveys.parentPreference" />
    </b-form-group>
    <hr class="my-4">
    <label class="font-weight-bold mb-3">
      希望進学先（学校名/チーム名など）
    </label>
    <b-form-group label="第1希望">
      <div class="display-field">
        {{ pathSurveys.firstPreferredSchool }}
      </div>
    </b-form-group>
    <b-form-group label="第2希望">
      <div class="display-field">
        {{ pathSurveys.secondPreferredSchool }}
      </div>
    </b-form-group>
    <b-form-group label="第3希望">
      <div class="display-field">
        {{ pathSurveys.thirdPreferredSchool }}
      </div>
    </b-form-group>
    <b-form-group label="第4希望">
      <div class="display-field">
        {{ pathSurveys.fourthPreferredSchool }}
      </div>
    </b-form-group>
    <b-form-group label="第5希望">
      <div class="display-field">
        {{ pathSurveys.fifthPreferredSchool }}
      </div>
    </b-form-group>
  </div>
</template>

<script>
import BaseCheckboxGroup from '@/components/parts/BaseCheckboxGroup.vue'
import DisplayTextarea from '@/components/parts/DisplayTextarea.vue'
import { residencePreferenceOptions, preferredPathOptions, examTypeOptions } from '@/helper/profile'

export default {
  components: {
    DisplayTextarea,
    BaseCheckboxGroup,
  },
  props: {
    pathSurveys: {
      type: Object,
      required: true,
    }
  },
  computed: {
    selectedPreferredPathOptions() {
      return preferredPathOptions.filter(option => this.pathSurveys.preferredPath.includes(option.value))
    },
    selectedExamTypeOptions() {
      return examTypeOptions.filter(option => this.pathSurveys.examType.includes(option.value))
    },
    selectedResidencePreferenceOptions() {
      return residencePreferenceOptions.filter(option => this.pathSurveys.residencePreference.includes(option.value))
    },
  },
}
</script>

<style lang="scss" scoped>
.path-surveys-display {
  .display-field {
    padding: 8px 12px;
    background-color: $grey15;
    border-radius: 4px;
    min-height: 40px;
    display: flex;
    align-items: center;
  }
}
</style>

<style lang="scss">
.display-checkbox-group {
  .custom-control-label {
    color: $black !important;
  }
}
</style>